import { useSelector } from 'react-redux';
import { GAME_CLASS, name } from './constants';
var gameTypesSelector = function (state) { return state[name]; };
var gameBalanceSelector = function (state) {
    return gameTypesSelector(state).data.gameBalance;
};
var activeGameSelector = function (state) {
    return gameTypesSelector(state).data.activeGame;
};
var selectedTournamentSelector = function (state) {
    return gameTypesSelector(state).meta.tournament;
};
var defaultGameUidSelector = function (state) { var _a; return (_a = gameTypesSelector(state).meta) === null || _a === void 0 ? void 0 : _a.defaultGameUid; };
var isEasyPlusSelector = function (state) { var _a; return ((_a = gameTypesSelector(state).data.activeGame) === null || _a === void 0 ? void 0 : _a.gameClass) === GAME_CLASS.EASY_PLUS; };
var isEasyTipSelector = function (state) {
    var _a, _b;
    return ((_a = gameTypesSelector(state).data.activeGame) === null || _a === void 0 ? void 0 : _a.gameClass)
        ? ((_b = gameTypesSelector(state).data.activeGame) === null || _b === void 0 ? void 0 : _b.gameClass) ===
            GAME_CLASS.EASY_TIP
        : undefined;
};
var activeGameErrorSelector = function (state) {
    return Boolean(gameTypesSelector(state).error);
};
export var useGameBalanceSelector = function () { return useSelector(gameBalanceSelector); };
export var useActiveGameSelector = function () { return useSelector(activeGameSelector); };
export var useTournamentSelector = function () {
    return useSelector(selectedTournamentSelector);
};
export var useDefaultGameUidSelector = function () {
    return useSelector(defaultGameUidSelector);
};
export var useIsEasyPlusSelector = function () { return useSelector(isEasyPlusSelector); };
export var useIsEasyTipSelector = function () { return useSelector(isEasyTipSelector); };
export var useActiveGameErrorSelector = function () {
    return useSelector(activeGameErrorSelector);
};
